import Vue from "vue";
import moment from "moment";
import api from "@/api/portal-beneficiario";

const baixarDemonstrativoIr = (codigoBeneficiario, ano) => {
  return Vue.api
    .get(api.baixarDemonstrativoIr(codigoBeneficiario, ano))
    .then(response => response)
    .catch(({ response }) => response);
};

const baixarDemonstrativoIrTodosContratos = (codigoBeneficiarios, ano) => {
  return Vue.api
    .get(api.baixarTodosDemonstrativoIr(codigoBeneficiarios, ano))
    .then(response => response)
    .catch(({ response }) => response);
};

const baixarExtratoDespesa = (codigoBeneficiario, codigoFatura) => {
  return Vue.api
    .get(api.baixarExtratoDespesa(codigoBeneficiario, codigoFatura))
    .then(response => response)
    .catch(({ response }) => response);
};

const baixarFatura = downloadId => {
  return Vue.api
    .get(api.baixarFatura(global.encodeURI(downloadId)))
    .then(response => response)
    .catch(({ response }) => response);
};

const buscaDadosReajuste = beneficiarioCartao => {
  return Vue.api
    .get(api.buscaDadosReajuste(beneficiarioCartao))
    .then(({ data }) => data);
};

const buscaDadosCartaoFrente = beneficiarioCartao => {
  return Vue.api
    .get(api.buscaDadosCartaoFrente(beneficiarioCartao))
    .then(({ data }) => data);
};

const buscaDadosCartaoVerso = beneficiarioCartao => {
  return Vue.api
    .get(api.buscaDadosCartaoVerso(beneficiarioCartao))
    .then(({ data }) => data);
};

const buscaExtratoDespesasFatura = (
  codigoBeneficiario,
  competenciaDe,
  competenciaAte,
  page,
  size,
  sort
) => {
  return Vue.api
    .get(
      api.buscaExtratoDespesasFatura(
        codigoBeneficiario,
        competenciaDe,
        competenciaAte,
        page,
        size,
        sort
      )
    )
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const getExtratosPormenorizado = payload => {
  return Vue.api
    .get(api.extratos_pormenorizado(payload))
    .then(response => response.data)
    .catch(({ response }) => response);
};

const downloadExtratos = payload => {
  return Vue.api
    .get(api.downloadExtratos(payload))
    .then(response => response)
    .catch(({ response }) => response);
};

const buscaFaturasBeneficiario = (codigoBeneficiario, page, size, sort) => {
  return Vue.api
    .get(api.buscaFaturasBeneficiario(codigoBeneficiario, page, size, sort))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const buscaParametroValorTipoBooleanAtivo = parametroId => {
  return Vue.api
    .get(api.buscaParametroValorTipoBooleanAtivo(parametroId))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const buscaPeriodoAnoDemonstrativoIr = codigoBeneficiario => {
  return Vue.api
    .get(api.buscaPeriodoAnoDemonstrativoIr(codigoBeneficiario))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const getAnexo = arquivoId => {
  return Vue.api
    .get(api.getAnexo(arquivoId), {
      responseType: "blob"
    })
    .then(response => response.data);
};

const getCartaPortabilidade = (gerarFamilia, codigoBeneficiario) => {
  return Vue.api
    .get(api.downloadCartaPortabilidade(gerarFamilia, codigoBeneficiario))
    .catch(({ response }) => response);
};

const getCep = cep => {
  if (cep === null || cep === "") {
    return null;
  }

  return Vue.api
    .get(api.cep(cep))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const getHistoricoUtilizacoes = (
  tipo,
  beneficiarioCartao,
  mesAtendimento,
  competenciaDe,
  competenciaAte
) => {
  const query = `{
    historicoUtilizacoes(
      beneficiarioId: "${beneficiarioCartao}",
      mesAtendimento: ${mesAtendimento ? mesAtendimento : null},
      competenciaDe: ${competenciaDe ? competenciaDe : null},
      competenciaAte: ${competenciaAte ? competenciaAte : null},
      tipoDespesa: ${tipo}
    ) {
      id
      competencia
      beneficiarioId
      cartaoUnimed
      cartaoContrato
      cartaoBeneficiario
      cartaoDependente
      codigoProcedimento
      descricaoProcedimento
      nomeRazaoExecutante
      cpfCnpjExecutante
      cidadeExecutante
      especialidadeMedica
      quantidadeExecutada
      motivoEncerramento
      dataAtendimento
      mesAtendimento
      dataFinalInternacao
      motivoSaidaInternacao
      valorPagoPrestador
      tipoDespesa
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getDocumentos = payload => {
  return Vue.api.get(api.buscaDocumentos(payload));
};

const buscaBeneficiariosUsuario = () => {
  return Vue.api.get(api.beneficiariosUsuario()).then(({ data }) => data);
};

const getParametro = parametroId => {
  const dateFormat = "YYYY-MM-DD";
  const currentDate = moment().format(dateFormat);
  const query = `{
    parametros(filter: { all: ["id=${parametroId}"] }) {
      content {
        parametroValores {
          valor
          dataInativacao
          jsonValor
        }
      }
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(({ data }) => data.data?.parametros?.content[0]?.parametroValores[0])
    .then(response =>
      response &&
      (response.dataInativacao === null ||
        moment(response.dataInativacao).format(dateFormat) > currentDate)
        ? response.valor || response.jsonValor
        : null
    );
};

const getParametroCartaoVerso = parametroId => {
  const dateFormat = "YYYY-MM-DD";
  const currentDate = moment().format(dateFormat);
  const query = `{
    parametros(filter: { all: ["id=${parametroId}"] }) {
      content {
        parametroValores {
          valor
          dataInativacao
        }
      }
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(({ data }) => data.data?.parametros?.content[0])
    .then(
      response =>
        response?.parametroValores &&
        response?.parametroValores.filter(
          e =>
            e.dataInativacao === null ||
            moment(e.dataInativacao).format(dateFormat) > currentDate
        )
    );
};

const getReajusteDefinitivo = beneficiarioCartao => {
  const query = `{
    pinss(beneficiarioCartao: "${beneficiarioCartao}") {
      pinssReajusteApb {
        id
        periodo
        percentual
        motivoReajuste
      }
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(({ data }) => data.data.pinss?.pinssReajusteApb || []);
};

const getPinss = beneficiarioCartao => {
  const query = `{
    pinss(beneficiarioCartao: "${beneficiarioCartao}") {
      pinssApb {
        id
        pessoaNomeCompleto
        pessoaDataNascimento
        numeroCns
        beneficiarioSituacao
        beneficiarioCartao
        beneficiarioCartaoDigito
        beneficiarioInicioVigencia
        cpt
        contrato
        contratoInicioVigencia
        planoCelebrado
        listaGrupoMunicipios
        planoSegmentacao
        planoTipoAcomodacao
        planoAbrangenciaGeografica
        planoRedeAtendimento
        planoRegistroAns
        planoTipoPlanoTitulo
        planoTipoPlano
        planoTipoContratacao
        planoNomeComercial
        planoFormPreco
        contratanteNomeFantasia
        contratanteCartao
        unimedRegistroAns
        administradoraNomeFantasia
        operadoraSacTelefone
        operadoraSacSite
        operadoraOuvidoriaTelefone
        operadoraNomeFantasia
        operadoraRazaoSocial
        repasseNomeFantasia
        repasseRazaoSocial
        repasseRegistroAns
        ansTelefone
        ansSite
        carenciaHospitalar
        carenciaHospitalarCumprir
        carenciaAmbulatorial
        carenciaAmbulatorialCumprir
        carenciaPartoTermo
        carenciaPartoTermoCumprir
        carenciaOdonto
        carenciaOdontoCumprir
        contratacaoPlano
        percentualUltimoReajuste
        motivoUltimoReajuste
        competenciaUltimoReajuste
      }
      pinssReajusteApb {
        id
        periodo
        percentual
        motivoReajuste
      }
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(({ data }) => data.data.pinss);
};

const getValoresPlano = codigoBeneficiario => {
  return Vue.api
    .get(api.valoresPlano(codigoBeneficiario))
    .then(({ data }) => data);
};

const getTiposContaBancaria = () => {
  const query = `{
    tiposContaBancaria {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.tiposContaBancaria);
};

const getMovimentoFormularios = movimentoId => {
  const query = `{
    formularios(movimentoId: ${movimentoId}) {
      id
      filename
      arquivoId
      mediaType
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.formularios);
};

const downloadFormulario = formularioId => {
  return Vue.api.get(api.downloadFormulario(formularioId), {
    responseType: "arraybuffer"
  });
};

const verificaRepasse = (cartaoBeneficiario, unimed) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "X-Unimed": unimed
  };
  const data = global.encodeURI(`cartaoBeneficiario=${cartaoBeneficiario}`);

  return Vue.api
    .post(api.verificaRepasse, data, { headers })
    .then(({ data }) => data);
};

const getAcaoJudicialFatura = faturaId => {
  return new Promise((resolve, reject) => {
    Vue.api
      .get(api.validaFaturaAcaoJudicial(faturaId))
      .then(({ data }) => {
        resolve({ mensagem: data.mensagem, bloqueio: data.bloqueio });
      })
      .catch(error => {
        reject(error);
      });
  });
};

const validaVencimentoFatura = faturaId => {
  return new Promise((resolve, reject) => {
    Vue.api
      .get(api.validaVencimentoFatura(faturaId))
      .then(({ data }) => {
        resolve({ mensagem: data.mensagem });
      })
      .catch(error => {
        reject(error);
      });
  });
};

const verificarCadastroBeneficiarioDesatualizado = codigoBeneficiario => {
  return new Promise((resolve, reject) => {
    Vue.api
      .get(api.cadastroBeneficiarioDesatualizado(codigoBeneficiario))
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response }) => {
        reject(response);
      });
  });
};

const gravaHistoricoAtualizacaoCadastral = payload => {
  return new Promise((resolve, reject) => {
    Vue.api
      .post(api.gravaHistoricoAtualizacaoCadastral, payload)
      .then(() => resolve())
      .catch(({ response }) => reject(response));
  });
};

const getDetalhamentoRenegociacao = faturaId => {
  return Vue.api
    .get(api.getDetalhamentoRenegociacao(faturaId))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

export {
  baixarDemonstrativoIr,
  baixarDemonstrativoIrTodosContratos,
  baixarExtratoDespesa,
  baixarFatura,
  buscaBeneficiariosUsuario,
  buscaDadosCartaoFrente,
  buscaDadosCartaoVerso,
  buscaExtratoDespesasFatura,
  buscaFaturasBeneficiario,
  buscaParametroValorTipoBooleanAtivo,
  buscaPeriodoAnoDemonstrativoIr,
  getAnexo,
  getCep,
  getHistoricoUtilizacoes,
  getDocumentos,
  getParametro,
  getReajusteDefinitivo,
  getPinss,
  getValoresPlano,
  getTiposContaBancaria,
  getMovimentoFormularios,
  downloadFormulario,
  getCartaPortabilidade,
  verificaRepasse,
  getAcaoJudicialFatura,
  validaVencimentoFatura,
  buscaDadosReajuste,
  getExtratosPormenorizado,
  downloadExtratos,
  getParametroCartaoVerso,
  verificarCadastroBeneficiarioDesatualizado,
  gravaHistoricoAtualizacaoCadastral,
  getDetalhamentoRenegociacao
};
